<template>
  <div class="row-created-by-date">
    <div class="created-by">{{ createdBy }}</div>
    <div class="created-at">{{ formattedDateTime }}</div>
  </div>
</template>

<script>
export default {
  name: 'RowCreatedByDate',
  props: {
    createdBy: {
      type: String,
      required: true,
    },
    createdAt: {
      type: String,
      required: true,
    },
  },
  computed: {
    formattedDateTime() {
      if (!this.createdAt) return '';

      // Format: HH:mm:ss DD/MM/YYYY -> split into time and date
      const trimmed = this.createdAt.trim();
      const spaceIndex = trimmed.indexOf(' ');

      if (spaceIndex > 0) {
        const time = trimmed.substring(0, spaceIndex);
        const date = trimmed.substring(spaceIndex + 1);
        return `${time}\n${date}`;
      }

      return this.createdAt;
    },
  },
};
</script>

<style scoped>
.row-created-by-date {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  line-height: 1.4;
}

.created-by {
  margin-bottom: 2px;
  color: #333;
}

.created-at {
  color: #666;
  font-size: 0.9em;
  white-space: pre-line;
}
</style>
